export default __webpack_public_path__ + "static/media/page-title-cases-uz.422d9d52.svg";